import commonZhHK from './common_zh-HK'

const kstZhHK = {
  kst: {
    ...commonZhHK,
  }
}

export default kstZhHK